import React, { Component } from 'react';

import Title from '../Shared/Title';
import IntroSlide from './Intro';
import HowToSlide from './HowTo';
import ChallengeSlide from './Challenge';
import ResultSlide from './Result';
import AnswerSlide from './Answer';
import Button from '../Shared/Button';
import BigTop from '../Shared/BigTop';

class Slide extends Component {
  render() {
    let slide;

    switch (this.props.type) {
      case 'intro':
        slide = <IntroSlide { ...this.props }/>;
        break;
      case 'how-to':
        slide = <HowToSlide { ...this.props }/>;
        break;
      case 'challenge':
        slide = <ChallengeSlide { ...this.props }/>;
        break;
      case'results-success':
        slide = <ResultSlide { ...this.props }/>;
        break;
      case'results-error':
        slide = <ResultSlide { ...this.props }/>;
        break;
      case 'show-answer':
        slide = <AnswerSlide { ...this.props }/>;
        break;
    }

    let activeButton = true;

    // disable button if challenge and answers aren't filled
    if(this.props.game_info && this.props.game_info.answers.length !== this.props.game_info.answers_count){
      activeButton = false;
    }

    let buttons;

    if(this.props.buttons){
      buttons = this.props.buttons.map((button, i) => {
        return <Button key={i} text={ button.text } goto={ button.goto } active={ activeButton } handleClick={ this.props.goto } game_info={ this.props.game_info } type={ button.type } btn_obj={ this.props.buttons }/>
      });
    }

    let introBigTop;
    if(this.props.challenge === 1 && this.props.type === 'intro'){
      introBigTop = <BigTop { ...this.props }/>
    }

    return (
      <div className={`gm-slide gm-slide--${ this.props.type }`}>
        { introBigTop }
        { slide }
        <div className="gm-slide__button-wrapper">
          { buttons }
        </div>
      </div>
    );
  }
}

export default Slide;



// WEBPACK FOOTER //
// ./src/components/Slides/index.js